import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import {
  performVWBasicLayerClose,
  performVWBasicLayerLoad,
} from '@/analytics/events';
import { useTribalContext } from '@/context/tribal';
import IconModal from '@/modules/components/IconModal/IconModal';
import { SectionNames } from '@/analytics/sectionNames';
import {
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';

export const WLTPModal = ({
  configurations,
  sectionName,
}: {
  configurations: GlobalStoreStateConfiguration[];
  sectionName: SectionNames;
}) => {
  const { contentManager, analyticsManager, analyticsBuilder } =
    useTribalContext();
  const { retailers } = useGlobalStore((state) => state.app);

  const analyticsCommonFields = {
    configurations,
    sectionName,
    retailers,
    analyticsManager,
    analyticsBuilder,
  };

  return (
    <IconModal
      title={contentManager.get('wltp-more-info')}
      body={
        <Text tag={TextTag.div} appearance={TokenTextAppearance.copy100}>
          <p>{contentManager.get('wltp-weighted-more-info')}</p>
          <p>{contentManager.get('wltp-sustaining-more-info')}</p>
          <p>{contentManager.get('wltp-electric-range-more-info')}</p>
        </Text>
      }
      openCallback={() => performVWBasicLayerLoad(analyticsCommonFields)}
      closeCallback={() => performVWBasicLayerClose(analyticsCommonFields)}
    />
  );
};
